import { BookOpenCheck, CalendarClock, RotateCcw } from "lucide-react";
import type { UpdatesData } from "../types/content";
import { GitHubMark } from "./GitHubMark";

type ReadingRailProps = {
  progress: number;
  updates: UpdatesData;
};

export function ReadingRail({ progress, updates }: ReadingRailProps) {
  const latest = updates.entries[0];

  return (
    <aside className="reading-rail" aria-label="阅读辅助">
      <section>
        <div className="rail-title">
          <BookOpenCheck aria-hidden="true" />
          <span>阅读进度</span>
          <strong>{progress}%</strong>
        </div>
        <div
          className="progress-track"
          role="progressbar"
          aria-label="阅读进度"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={progress}
        >
          <span style={{ width: `${progress}%` }} />
        </div>
        <a className="rail-action" href="#reader">
          继续阅读
        </a>
      </section>

      <section>
        <div className="rail-title">
          <CalendarClock aria-hidden="true" />
          <span>每周官方更新</span>
        </div>
        {latest ? (
          <article className="latest-update">
            <time dateTime={latest.publishedAt}>{latest.publishedAt}</time>
            <a href={latest.url} target="_blank" rel="noreferrer">
              {latest.title}
            </a>
            <span>重要性 {latest.score}/100</span>
          </article>
        ) : (
          <div className="empty-update">
            <RotateCcw aria-hidden="true" />
            <p>候选只在 Brad 明确确认后进入正式内容。</p>
          </div>
        )}
        <a className="rail-link" href="#weekly-updates">
          查看更新机制
        </a>
      </section>

      <section className="github-rail">
        <GitHubMark />
        <p>勘误、复现实验与官方资料都欢迎提交。</p>
        <a
          href="https://github.com/yizhiyanhua-ai/agent-harness-engineering-zh/issues"
          target="_blank"
          rel="noreferrer"
        >
          参与维护
        </a>
      </section>
    </aside>
  );
}
